import React from "react";

export default () => <div>Argg...</div>;



// WEBPACK FOOTER //
// ./src/app/Error404.js